import {
  Avatar,
  Divider,
  Grid,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import React, { useMemo, useRef } from "react";
import { FaEdit, FaEye, FaTimes, FaUserFriends } from "react-icons/fa";
import { RiVisaFill } from "react-icons/ri";
import CustomButton from "../../components/CustomButton/Index";
import CustomInputField from "../../components/CustomInputField/Index";
import CustomPill from "../../components/CustomPill/Index";
import CustomTable from "../../components/CustomTable/Index";
import endPoints from "../../config/endPoint";
import DashboardLayout from "../../layouts";
import offerStyles from "../../styles/pages/VisaCategory/index.style";
import axios from "axios";
import CustomTimeTable from "../../components/CustomTimeTable/Index";
import CountryTable from "../../components/CountryTable/Index";
import slugify from "react-slugify";
import { storage } from "../../firebase_config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import { MdLogout } from "react-icons/md";
import DashboardHeader from "../../components/DashHeader/Index";
import url from "../../API";
import JoditEditor from "jodit-react";
export default function Settings() {
  const navigate = useNavigate();
  const classes = offerStyles();
  const formData = new FormData();
  const location = useLocation();
  const { updateId } = location.state || {};
  const [state, setState] = React.useState({
    privacy_description: "",
    terms_and_condition: "",
    email: "",
    phone: null,
    address: "",
    contact_id: "",
    privacy_id: "",
    isUpdate: false,
  });
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: "",
    }),
    []
  );
  const [visaList, setVisaList] = React.useState([]);
  const fetchContactData = async () => {
    try {
      const loginHeaders = new Headers();
      loginHeaders.append("Content-Type", "application/json");

      const authToken = localStorage.getItem("tkn");
      if (authToken) {
        loginHeaders.append("Authorization", `Bearer ${authToken}`);
      }

      const requestOptions = {
        method: "GET",
        headers: loginHeaders,
      };

      const res = await fetch(
        url + "contactinformation/getallcontactinformation",
        requestOptions
      );
      const contact_data = await res.json();

      return contact_data.ContactInformation.length == 0
        ? null
        : contact_data.ContactInformation[0];
    } catch (e) {
      //console.log(e);
      return null;
    }
  };

  const fetchPrivacyData = async () => {
    try {
      const loginHeaders = new Headers();
      loginHeaders.append("Content-Type", "application/json");

      const authToken = localStorage.getItem("tkn");
      if (authToken) {
        loginHeaders.append("Authorization", `Bearer ${authToken}`);
      }

      const requestOptions = {
        method: "GET",
        headers: loginHeaders,
      };

      const res = await fetch(
        url + "PrivacyPolicy/GetAllPrivacyPolicy",
        requestOptions
      );
      const privacy_data = await res.json();

      return privacy_data.Privacy_Policy.length == 0
        ? null
        : privacy_data.Privacy_Policy[0];
    } catch (e) {
      //console.log(e);
      return null;
    }
  };

  const table = async () => {
    const contact_data = await fetchContactData();
    const privacy_data = await fetchPrivacyData();

    if (contact_data && privacy_data) {
      setState({
        privacy_description:privacy_data.Privacy_Policy,
        terms_and_condition: privacy_data.Term_Condition,
        email: contact_data.email_id,
        phone: contact_data.phone_number,
        address: contact_data.address,
        contact_id: contact_data.id,
        privacy_id: privacy_data.id,
        isUpdate: true,
      });
    }
  };

  React.useEffect(() => {
    table();
  }, []);

  const handleUpdateVisaCategory = async () => {
    if (
      !!state.privacy_description &&
      !!state.terms_and_condition &&
      !!state.email &&
      !!state.phone &&
      !!state.address
    ) {
      if (!state.email.endsWith(".com")) {
        toast.error("Email is not valid. It should end with '.com'", {
          position: "top-center",
        });
        return; // Exit the function if the email is not valid
      }

      try {
        const loginHeaders = new Headers();
        loginHeaders.append("Content-Type", "application/json");

        // Assuming you have an authorization token stored in localStorage
        const authToken = localStorage.getItem("tkn");
        if (authToken) {
          loginHeaders.append("Authorization", `Bearer ${authToken}`);
        }
        const data = {
          id: state.privacy_id,
          Privacy_Policy: state.privacy_description,
          Term_Condition: state.terms_and_condition,
        };
        const requestOptions = {
          method: "POST",
          headers: loginHeaders,
          body: JSON.stringify(data),
        };
        const res = await fetch(
          url + "PrivacyPolicy/updatePrivacyPolicy",
          requestOptions
        );
        const actualData = await res.json();
        //console.log(actualData);
        // setVisaList(actualData.Country);
        if (actualData.status != 200) {
          toast.error(actualData.message, {
            position: "top-center",
          });
        }
      } catch (err) {
        //console.log(err);
      }
      try {
        const loginHeaders = new Headers();
        loginHeaders.append("Content-Type", "application/json");

        // Assuming you have an authorization token stored in localStorage
        const authToken = localStorage.getItem("tkn");
        if (authToken) {
          loginHeaders.append("Authorization", `Bearer ${authToken}`);
        }
        const data = {
          id: state.contact_id,
          email_id: state.email,
          phone_number: state.phone,
          address: state.address,
        };
        const requestOptions = {
          method: "POST",
          headers: loginHeaders,
          body: JSON.stringify(data),
        };
        const res = await fetch(
          url + "contactinformation/updatecontactinformation",
          requestOptions
        );
        const actualData = await res.json();
        //console.log(actualData);
        // setVisaList(actualData.Country);
        if (actualData.status != 200) {
          toast.error(actualData.message, {
            position: "top-center",
          });
        } else {
          toast.success("Updated Sucessfully", {
            position: "top-center",
          });
        }
      } catch (err) {
        //console.log(err);
      }
    } else {
      toast.error("Fill all the information", {
        position: "top-center",
      });
    }
  };
  const handleCreateVisaCategory = async () => {
    if (
      !!state.privacy_description &&
      !!state.terms_and_condition &&
      !!state.email &&
      !!state.phone &&
      !!state.address
    ) {
      if (!state.email.endsWith(".com")) {
        toast.error("Email is not valid. It should end with '.com'", {
          position: "top-center",
        });
        return; // Exit the function if the email is not valid
      }

      try {
        const loginHeaders = new Headers();
        loginHeaders.append("Content-Type", "application/json");

        // Assuming you have an authorization token stored in localStorage
        const authToken = localStorage.getItem("tkn");
        if (authToken) {
          loginHeaders.append("Authorization", `Bearer ${authToken}`);
        }
        const data = {
          Privacy_Policy: state.privacy_description,
          Term_Condition: state.terms_and_condition,
        };
        const requestOptions = {
          method: "POST",
          headers: loginHeaders,
          body: JSON.stringify(data),
        };
        const res = await fetch(
          url + "PrivacyPolicy/createPrivacyPolicy",
          requestOptions
        );
        const actualData = await res.json();
        //console.log(actualData);
        // setVisaList(actualData.Country);
        if (actualData.status != 200) {
          toast.error(actualData.message, {
            position: "top-center",
          });
        }
      } catch (err) {
        //console.log(err);
      }
      try {
        const loginHeaders = new Headers();
        loginHeaders.append("Content-Type", "application/json");

        // Assuming you have an authorization token stored in localStorage
        const authToken = localStorage.getItem("tkn");
        if (authToken) {
          loginHeaders.append("Authorization", `Bearer ${authToken}`);
        }
        const data = {
          email_id: state.email,
          phone_number: state.phone,
          address: state.address,
        };
        const requestOptions = {
          method: "POST",
          headers: loginHeaders,
          body: JSON.stringify(data),
        };
        const res = await fetch(
          url + "contactinformation/createcontactinformation",
          requestOptions
        );
        const actualData = await res.json();
        //console.log(actualData);
        // setVisaList(actualData.Country);

        if (actualData.status != 200) {
          toast.error(actualData.message, {
            position: "top-center",
          });
        } else {
          toast.success("Created Sucessfully", {
            position: "top-center",
          });
        }
      } catch (err) {
        //console.log(err);
      }
    } else {
      toast.error("Fill all the information", {
        position: "top-center",
      });
    }
  };
  //console.log(state,"sttttaatttee");
  return (
    <div className={classes.container}>
      <DashboardLayout />
      <div className={classes.contentSection}>
        <DashboardHeader />
        <Divider className={classes.divider} />
        <div
          className={classes.contentHead}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {" "}
            <p style={{ marginTop: "2px", fontSize: "22px" }}>Settings</p>
          </div>
        </div>
        {/* <Divider className={classes.divider} /> */}
        <div className={classes.contentMain}>
          <div className={classes.contentMain} style={{ width: "100%" }}>
            <p>Privacy Policy</p>
            <Paper className={classes.paper} style={{ marginLeft: "16px" }}>
              <Grid
                container
                spacing={3}
                className="content"
                alignItems={"end"}
              >
                <Grid item xs={12}>
                <JoditEditor
                  ref={editor}
                  value={state.privacy_description}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    setState({
                      ...state,
                      privacy_description: newContent,
                    })
                  } // preferred to use only this option to update the content for performance reasons
                  onChange={(newContent) => {}}
                  config={config}
                />
                  
                </Grid>
              </Grid>
            </Paper>
          </div>{" "}
          <div className={classes.contentMain} style={{ width: "100%" }}>
            <p>Terms And Condition</p>
            <Paper className={classes.paper} style={{ marginLeft: "16px" }}>
              <Grid
                container
                spacing={3}
                className="content"
                alignItems={"end"}
              >
                <Grid item xs={12}>
                <JoditEditor
                  ref={editor}
                  value={state.terms_and_condition}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    setState({
                      ...state,
                      terms_and_condition: newContent,
                    })
                  } // preferred to use only this option to update the content for performance reasons
                  onChange={(newContent) => {}}
                  config={config}
                />
                  
                </Grid>
              </Grid>
            </Paper>
          </div>{" "}
          <div className={classes.contentMain} style={{ width: "100%" }}>
            <p>Contact Information</p>
            <Paper className={classes.paper} style={{ marginLeft: "16px" }}>
              <Grid
                container
                spacing={3}
                className="content"
                alignItems={"end"}
              >
                <Grid item xs={4}>
                <CustomInputField
  label="Phone"
  type="text" // Use 'text' type for better control over input
  fullWidth
  value={state.phone}
  onChange={(e) => {
    const input = e.target.value;
    // Allow digits and special characters like '+', '-', and limit to 20 characters
    const validInput = input.replace(/[^0-9+()-\s]/g, "").slice(0, 20);
    setState({
      ...state,
      phone: validInput,
    });
  }}
/>

                </Grid>
                <Grid item xs={4}>
                  <CustomInputField
                    label="Email"
                    fullWidth
                    value={state.email}
                    onChange={(e) =>
                      setState({
                        ...state,
                        email: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInputField
                    label="Address"
                    fullWidth
                    value={state.address}
                    onChange={(e) =>
                      setState({
                        ...state,
                        address: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Paper>
            {/* <Grid container spacing={4} className={classes.contentMain}>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={(e) => {
                    // navigate("/information_form");
                  }}
                >
                  Create
                </Button>
              </Grid>
            </Grid> */}
          </div>{" "}
          <Grid container spacing={4} className={classes.contentMain}>
            <Grid item xs={9} />
            <Grid item xs={3}>
              {state.isUpdate ? (
                <>
                  {" "}
                  <CustomButton
                    text={"Update"}
                    variant="contained"
                    color="warning"
                    fullWidth
                    onClick={(e) => {
                      handleUpdateVisaCategory();
                    }}
                  />
                </>
              ) : (
                <>
                  {" "}
                  <CustomButton
                    text={"Create"}
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                      handleCreateVisaCategory();
                    }}
                  />
                </>
              )}
            </Grid>
          </Grid>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}
